import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Logo } from '../Logo';

const StyledHeader = styled('header')(({ theme }) => ({
  position: 'relative',
  height: 'var(--header-height)',
  borderBottom: '1px solid var(--color-general-grey-300)',
  backgroundColor: 'var(--color-white)',
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: '1',
  boxSizing: 'border-box',
  padding: `${theme.spacing(2)} ${theme.spacing(5)}`,
  background: '#f9f9f9',
  gap: theme.spacing(4),
}));

const Right = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export type AppHeaderProps = {
  right: ReactNode;
};

export const AppHeader = ({ right }: AppHeaderProps) => {
  return (
    <StyledHeader>
      <a href="/">
        <Logo />
      </a>
      <Right>{right}</Right>
    </StyledHeader>
  );
};
